import React from 'react';
import { GLASS_DESIGNS } from '../../assets/glassCatalogue';
import { type DoorConfiguration } from '../../types/doorConfiguration';
import { ChoiceCard } from '../ChoiceCard';

export const GlassStage: React.FC<{
  configuration: DoorConfiguration;
  onChange: (next: DoorConfiguration) => void;
}> = ({ configuration, onChange }) => {
  const selectedId = configuration.glazing[0]?.id;

  return (
    <div className="flex flex-col gap-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Glass</p>
      <div role="radiogroup" aria-label="Glass" className="grid grid-cols-2 gap-3">
        {GLASS_DESIGNS.map((design) => {
          const selected = selectedId === design.id;
          return (
            <ChoiceCard
              key={design.id}
              title={design.name}
              selected={selected}
              tickPlacement="top-right"
              onSelect={() => onChange({ ...configuration, glazing: [{ id: design.id }] })}
            >
              <div className="aspect-[4/3] overflow-hidden rounded-md border border-border bg-muted">
                <img src={design.publicPath} alt="" className="h-full w-full object-cover" />
              </div>
            </ChoiceCard>
          );
        })}
      </div>
      <p className="text-sm text-muted-foreground">
        The same glass design is clipped into every aperture on the selected door style.
      </p>
    </div>
  );
};
